import * as yup from 'yup';
import docs from './attachments';
import {
  aceite,
  aceiteAlteracaoDadosBancarios,
  aceiteInss,
  consentimentoDadosSensiveis,
  consentimentoDescontoFolha,
  declaracaoTipoRegime,
  declaracaoVeracidade,
  estaAposentadoINSS,
  numeroDoBeneficio,
  parcelasDoPagamento,
  tipoRegime,
} from './utils/rulesByKey';

export const resgateSchema = yup.object({
  ...estaAposentadoINSS,
  ...numeroDoBeneficio,
  ...parcelasDoPagamento,
  ...consentimentoDadosSensiveis(),
  ...consentimentoDescontoFolha,
  ...tipoRegime,
  ...aceite,
  ...declaracaoTipoRegime,
  ...aceiteInss,
  ...aceiteAlteracaoDadosBancarios,
  ...declaracaoVeracidade,
  ...docs.resgateDocs.rules,
});

export const resgateInitialValues = {
  estaAposentadoINSS: '',
  numeroDoBeneficio: '',
  parcelasDoPagamento: '',
  consentimentoDadosSensiveis: false,
  consentimentoDescontoFolha: false,
  declaracaoTipoRegime: false,
  tipoRegime: '',
  aceite: false,
  aceiteInss: false,
  aceiteAlteracaoDadosBancarios: false,
  declaracaoVeracidade: false,
  ...docs.resgateDocs.initialValues,
};

export const resgateDocs = {
  ...docs.resgateDocs.docs,
};
